import { Calendar } from 'lucide-react';

interface Props {
  label: string;
  value: string;
  onChange: (v: string) => void;
}

export function DatePicker({ label, value, onChange }: Props) {
  // Derive a stable id from the label so htmlFor wires correctly
  const id = `datepicker-${label.toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <div>
      <label
        htmlFor={id}
        className="mb-1.5 block text-[10.5px] font-medium uppercase tracking-[0.14em] text-muted-foreground"
      >
        {label}
      </label>
      <div className="relative">
        <Calendar
          className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground"
          strokeWidth={1.75}
        />
        <input
          id={id}
          type="date"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="num h-10 w-full rounded-md border border-border bg-surface pl-9 pr-3 text-sm outline-none focus:ring-2 focus:ring-ring/30"
        />
      </div>
    </div>
  );
}
